import { render, staticRenderFns } from "./index_J.vue?vue&type=template&id=21e40887&scoped=true&"
import script from "./index_J.vue?vue&type=script&lang=js&"
export * from "./index_J.vue?vue&type=script&lang=js&"
import style0 from "./index_J.vue?vue&type=style&index=0&id=21e40887&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e40887",
  null
  
)

export default component.exports